export enum QUERY_NAME {
  submission = 'submission',
  submissions = 'submissions',
  studyName = 'studyName',
  organizationName = 'organizationName',
}
